<template>
  <div class="preview_container" >
    <div>
      ●デザインNo. {{ cart.stock_design_code }}
    </div>
    <div class="preview_front">
      <part v-for="part in cart.parts" :key="'f_'+part.id" :part="part" :reverse="0"></part>
      <letter v-for="letter in cart.letters" :key="'fl_'+letter.id" :letter="letter" :reverse="0"></letter>
    </div>
    <div class="preview_back" style="position:relative;  height: 90px; float:left;">
      <part v-for="part in cart.parts" :key="'b_'+part.id" :part="part" :reverse="1"></part>
      <letter v-for="letter in cart.letters" :key="'bl_'+letter.id"  :letter="letter" :reverse="1"></letter>
    </div>
    <br class="clearfix">
    <div>
      ▪{{cart.category.name | stripTags}}<br>
      タイプ：{{cart.figure.name | stripTags}}<br>
      デザイン：{{cart.design.name | stripTags}}<br>
      <div v-for="pack in cart.packs">
        サイズ：{{pack.size_name}}<br>
        単価：{{ cartStockDesignPrice(cart) | currency }}<br>
        枚数：{{pack.value}}<br>
        <span v-show="pack.number">#{{pack.number}} {{pack.name | stripTags}}</span>
      </div>
    </div>
    <br>
    <div>
      ▪カラー
      <br>
      <div v-for="part in cart.parts" class="color-block">
        <div class="color-label">
          {{part.label}}：
          <span class="color-name" v-if="selected_part_color(part)">{{ selected_part_color(part).name }}</span>
          <span class="color-price" v-if="selected_part_color(part) && selected_part_color(part).price">
          (+{{ selected_part_color(part).price | currency }})
        </span>
        </div>
      </div>
    </div>
    <br>
    <div v-if="cart_letters.length">
      ▪オプション
      <br>
      <div v-for="letter in cart_letters" class="letter-block">
        <div class="letter-name" v-if="letter.decoration">位置：{{ letter.name }}</div>
        <div>タイプ：{{ letter.decoration.name }}
          <span v-if="letter.decoration.price">(+{{ letter.decoration.price | currency }})</span>
        </div>
        <div class="letter-font" v-if="letter.decoration">
          <div v-if="letter.font">フォント：{{ letter.font.name }}</div>
          <div v-if="selected_letter_color(letter)">カラー：{{ selected_letter_color(letter).name }}
            <span v-if="letter.color && letter.color.price">(+{{ letter.decoration.color.price | currency }})</span>
          </div>
          <div>入力内容：{{ letter.word }}</div>
        </div>
      </div>
    </div>
    <div>
      ■小計：{{ cart_price | currency }}
    </div>
  </div>
</template>

<script>
  import Part from '../../../preview/Part.vue'
  import Letter from '../../../preview/Letter.vue'
  import {mapGetters} from 'vuex'

  export default {
    name: 'preview',
    components: {Part, Letter},
    props: ['cart'],
    methods: {
      selected_part_color(part){
        return part.designs_part.color;
      },
      selected_letter_color(letter){
        if (!letter.decoration){
          return;
        }
        return letter.decoration.color;
      }
    },
    computed: {
      ...mapGetters([
        'cartStockTotalPrice',
        'cartStockDesignPrice'
      ]),
      preview_cart() {
        return this.$store.state.cart;
      },
      category_name(){
        if (this.cart.category){
          return this.cart.category.name;
        }
      },
      figure_name(){
        if (this.cart.figure){
          return this.cart.figure.name;
        }
      },
      design_name(){
        if (this.cart.design){
          return this.cart.design.name;
        }
      },
      cart_letters() {
        return this.cart.letters.filter(letter => {
          if (!letter.decoration) return false;
          return letter.decoration.color_id !== null;
        });
      },
      cart_price() {
        let price = this.$store.getters.totalPrice(this.cart);
        console.log(price);

        return price;
      }
    },
  }
</script>

<style scoped>
  .preview_container {
    margin-top: 2rem;
  }
  .preview_front {
    width: 100px;
    position:relative;
    height: 90px;
    float:left;
  }

  .preview_back {
    width: 100px;
    position:relative;
    height: 90px;
    float:left;
  }
  .letter-block {
    margin-bottom: 1rem;
  }
  .clearfix {
    clear:both;
  }
</style>
